import type { MapAnalyticsTrack } from '../shared/analytics-schema.js';
import { SIGNIN_METHODS, signinSource } from '../shared/signin-analytics.js';
import { isAnalyticsOptedOut } from './analytics-identity.js';

const key = 'drawonamap:pending-signin:v1';
const lifetime = 15 * 60_000;

export function startSignin(track: MapAnalyticsTrack, method: string, source: string): void {
  if (isAnalyticsOptedOut() || !SIGNIN_METHODS.has(method)) return;
  const props = { method, signin_source: signinSource(source), tracking_version: '1' };
  try { sessionStorage.setItem(key, JSON.stringify({ ...props, started_at: Date.now() })); } catch {}
  track('signin_started', props);
}

/** A successful account read proves return to the app, not account creation or a saved map. */
export function completeSignin(track: MapAnalyticsTrack, excluded = false, signedIn = true): void {
  if (!signedIn) return;
  try {
    const stored = sessionStorage.getItem(key);
    if (!stored) return;
    sessionStorage.removeItem(key);
    const pending = JSON.parse(stored);
    const age = Date.now() - pending.started_at;
    if (excluded || !SIGNIN_METHODS.has(pending.method) || !Number.isFinite(age) || age < 0 || age > lifetime) return;
    track('signin_returned', { method: pending.method, signin_source: signinSource(pending.signin_source), tracking_version: '1' });
  } catch { /* Storage and analytics must not prevent sign-in. */ }
}
